export enum TemplateType {
    Email,
    Pdf
}